import { useContext, useEffect } from 'react';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { LoadingState } from '../../../utils/loadingState';
import { fetchListingAgents } from '../../listingAgent/listingAgentReducer';
import { AuthContext } from '@urbanx/agx.auth.client';

const ListingAgentSelectorPreloader = () => {
  const { loadingState: agentsLoadingState } = useAppSelector((state) => state.listingAgent);

  const dispatch = useAppDispatch();

  const { getAuthToken } = useContext(AuthContext);

  useEffect(() => {
    if (agentsLoadingState !== LoadingState.NotLoaded) return;

    getAuthToken().then((token) => {
      if (!token) return;
      dispatch(fetchListingAgents(token));
    });
  }, [agentsLoadingState]);

  return <></>;
};

export default ListingAgentSelectorPreloader;
